// extracted by mini-css-extract-plugin
export default {"carouselContainer":"_14VZR","promoCodeCard":"CnUJX","promoInstructions":"dibvd","noPromos":"VOVrc"};